module.exports = __webpack_public_path__ + "img/couples_12_V.d05332a7.webp";